import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  stripe_publishable_key 
} from '../../../config';
import PlanSelectionPage from './PlanSelectionPage';

export default function ChatbotPricing() {
    return <PlanSelectionPage />
}